export const APP_URL = "https://www.quantifiction.com";
export const SAMPLE_REPORT_URL =
  "https://app.quantifiction.com/public/DYHYdE5bMX0m1f1qCk24";
export const INFO_EMAIL = "info@quantifiction.com";
export const SUPPORT_EMAIL = "support@quantifiction.com";
export const FEEDBACK_LINK =
  "https://docs.google.com/forms/d/e/1FAIpQLSdQCBaSZ1WhBg_z9RlyaHXcU4UAxN7zZKPoMwpyJK_4Zc8XuQ/viewform";
export const SIGNUP_LINK = "https://app.quantifiction.com/signup";
export const LOGIN_LINK = "https://app.quantifiction.com/login";



// WEBPACK FOOTER //
// ./src/utils/Constants.ts